import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import Comune from '../models/comune.model';

@Injectable({
  providedIn: 'root'
})
export class ComuniLocalService {

  comuni: Array<Comune>|null = null;
  province: Array<any> |null =null;

  constructor(
    private httpClient: HttpClient
  ) { }

  async preload(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      if (!!this.comuni && !!this.comuni.length) { return resolve(true); }
      this.httpClient.get(`${environment.appBaseUrl}/assets/data/Comuni.json`)
        .toPromise()
        .then((response: Array<any>) => {
          this.comuni = response.map((item: any) => Comune.fromObject(item, new Comune()));
          this.loadProvince();
          return resolve(true);
        })
        .catch((error: any) => {
          console.log(error);
          return resolve(false);
        });
    });
  }

  async loadProvince(){
    this.province=['AG'
    ,'AL'
    ,'AN'
    ,'AO'
    ,'AP'
    ,'AQ'
    ,'AR'
    ,'AT'
    ,'AV'
    ,'BA'
    ,'BG'
    ,'BI'
    ,'BL'
    ,'BN'
    ,'BO'
    ,'BR'
    ,'BS'
    ,'BZ'
    ,'CA'
    ,'CB'
    ,'CE'
    ,'CH'
    ,'CL'
    ,'CN'
    ,'CO'
    ,'CR'
    ,'CS'
    ,'CT'
    ,'CZ'
    ,'EE'
    ,'EN'
    ,'FC'
    ,'FE'
    ,'FG'
    ,'FI'
    ,'FR'
    ,'GE'
    ,'GO'
    ,'GR'
    ,'IM'
    ,'IS'
    ,'KR'
    ,'LC'
    ,'LE'
    ,'LI'
    ,'LO'
    ,'LT'
    ,'LU'
    ,'MC'
    ,'ME'
    ,'MI'
    ,'MN'
    ,'MO'
    ,'MS'
    ,'MT'
    ,'NA'
    ,'NO'
    ,'NU'
    ,'OR'
    ,'PA'
    ,'PC'
    ,'PD'
    ,'PE'
    ,'PG'
    ,'PI'
    ,'PN'
    ,'PO'
    ,'PR'
    ,'PT'
    ,'PU'
    ,'PV'
    ,'PZ'
    ,'RA'
    ,'RC'
    ,'RE'
    ,'RG'
    ,'RI'
    ,'RM'
    ,'RN'
    ,'RO'
    ,'SA'
    ,'SI'
    ,'SO'
    ,'SP'
    ,'SR'
    ,'SS'
    ,'SV'
    ,'TA'
    ,'TE'
    ,'TN'
    ,'TO'
    ,'TP'
    ,'TR'
    ,'TS'
    ,'TV'
    ,'UD'
    ,'VA'
    ,'VB'
    ,'VC'
    ,'VE'
    ,'VI'
    ,'VR'
    ,'VT'
    ,'VV']
  }

  async list(filterCallback: any|null = null): Promise<Array<Comune>> {
    await this.preload();

    if (!!filterCallback) {
      return this.comuni.filter(filterCallback);
    }

    return this.comuni;
  }


}
